import type { SegmentPickTarget } from "../../../../shape/segment/types";

export type SegmentInteractionTarget =
  | { kind: "segment"; part: "body"; segmentId: string }
  | {
      kind: "segment";
      part: "endpoint";
      segmentId: string;
      role: "start" | "end";
    }
  | {
      kind: "segment";
      part: "thickness";
      segmentId: string;
      side: 1 | 3;
    }
  | { kind: "segment"; part: "interior"; faceIndex: number };

/** Segment renderer içindeki geçiş adı; üst interaction katmanına çıkmaz. */
export type DesignerTarget = SegmentInteractionTarget;

export function sameDesignerTarget(
  first: DesignerTarget | null,
  second: DesignerTarget | null,
): boolean {
  if (first === second) return true;
  if (!first || !second) return false;
  if (first.part !== second.part) return false;
  if (first.part === "interior" && second.part === "interior") {
    return first.faceIndex === second.faceIndex;
  }
  if (first.part === "endpoint" && second.part === "endpoint") {
    return (
      first.segmentId === second.segmentId && first.role === second.role
    );
  }
  if (first.part === "thickness" && second.part === "thickness") {
    return first.segmentId === second.segmentId && first.side === second.side;
  }
  return (
    first.part === "body" &&
    second.part === "body" &&
    first.segmentId === second.segmentId
  );
}

/** Planar graph'ın mevcut target tipinden ortak interaction target'ına geçiş. */
export function designerTargetFromSegmentPick(
  target: SegmentPickTarget,
): SegmentInteractionTarget | null {
  switch (target.kind) {
    case "segmentWall":
      return { kind: "segment", part: "body", segmentId: target.segmentId };
    case "centerlineEndpoint":
      return {
        kind: "segment",
        part: "endpoint",
        segmentId: target.segmentId,
        role: target.role,
      };
    case "logicalEdge":
      if (target.ref.logicalEdgeIndex !== 1 && target.ref.logicalEdgeIndex !== 3) {
        return null;
      }
      return {
        kind: "segment",
        part: "thickness",
        segmentId: target.ref.segmentId,
        side: target.ref.logicalEdgeIndex,
      };
    case "interior":
      return { kind: "segment", part: "interior", faceIndex: target.faceIndex };
  }
}

/** Geçiş süresince mevcut segment drag/highlight API'sini korur. */
export function segmentPickFromDesignerTarget(
  target: SegmentInteractionTarget,
): SegmentPickTarget {
  switch (target.part) {
    case "body":
      return { kind: "segmentWall", segmentId: target.segmentId };
    case "endpoint":
      return {
        kind: "centerlineEndpoint",
        segmentId: target.segmentId,
        role: target.role,
      };
    case "thickness":
      return {
        kind: "logicalEdge",
        ref: { segmentId: target.segmentId, logicalEdgeIndex: target.side },
      };
    case "interior":
      return { kind: "interior", faceIndex: target.faceIndex };
  }
}
